import '@assets/sharedStyles/modal.scss';
import { Button, Modal } from 'antd';
import { FiAlertCircle } from 'react-icons/fi';
import { GrFormClose } from 'react-icons/gr';

const InactiveCompanyErrorModal = ({ isModalVisible, handleModalVisible }) => {
  const CloseIcon = () => (
    <div className="close-icon-container">
      <GrFormClose size={25} color="#fffafe" />
    </div>
  );

  return (
    <Modal
      className="modal"
      centered
      open={isModalVisible}
      closeIcon={<CloseIcon />}
      footer={null}
      title="Aktif Olmayan Hesap"
      onCancel={() => handleModalVisible()}
    >
      <div className="modal-context-container">
        <div style={{ textAlign: 'center', marginBottom: '-10px' }}>
          <FiAlertCircle size={50} color="#ff4d4f" />
        </div>
        <p className="modal-context-info">Hesap aktif görünmemektedir.</p>
        <div className="modal-context-footer">
          <Button
            className="modal-button"
            onClick={() => handleModalVisible((value) => !value)}
          >
            Tamam
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default InactiveCompanyErrorModal;
